function downsize(imgurl, size) {
    return imgurl.replace(/\.(\w+)\?/, `_${size}x.$1?`);
}

function extractSrc(img) {
    const size = 600;
    const ie = $(img);
    let src = ie.data("src");
    if (!src) {
        let srcset = ie.data("srcset");
        if (!srcset) return null;
        srcset = srcset.split(",");
        for (let x of srcset) {
            let [url, siz] = x.split(" ");
            if (siz === `${size}w`) {
                return url;
            }
        }
        return null;
    }
    if (src.match("{width}")) src = src.replace("{width}", `${size}`);
    return src;
}

function hydrateCarousel(el, productHandle, callback) {
    const altImg = el.find(".product-item-mobile-carousel--link-alt-img img")

    const product = {};

    product.title = el.find(".ProductItem__Title span").first().text().replace(/\n/g, '').trim();
    product.price = el.find(".ProductItem__Price").first().text().trim();
    product.url = el.find(".ProductItem__ImageWrapper").first().attr("href");
    product.variantId = el.data("variant-id");
    product.id = el.data("product-id")
    // can't fully trust el.data('variant-id') because it might've updated from variable-products
    if (product.url.indexOf('variant=') > -1) {
        product.variantId = Number(product.url.split('variant=')[1])
    }

    const productImages = window.plp_tile_images[product.id]

    const featuredImageVariants = {}
    for (let variantId in window.plp_tile_variants[product.id]) {
        const img = window.plp_tile_variants[product.id][variantId].featured_image
        if (img) {
            featuredImageVariants[img.position] = Number(variantId)
        }
    }

    // duplicate the images object from ${productHandle}.json
    const fullImages = [] || productImages && productImages.map((img, i) => {
        return {
            position: i + 1,
            src: img,
            variant_id: featuredImageVariants[i + 1]
        }
    })

    // MODIFIED: Don't filter images by variant to ensure all images are displayed in the correct order
    // Original code was filtering images based on variant position
    // let thisVariantIndex = null
    // let nextVariantIndex = null
    // for (let i = 0; i < fullImages.length; i++) {
    //     if (fullImages[i].variant_id == product.variantId) {
    //         thisVariantIndex = i
    //     }
    //     else if (thisVariantIndex !== null && fullImages[i].variant_id) {
    //         nextVariantIndex = i
    //         break
    //     }
    // }
    //
    // if (nextVariantIndex == null) {
    //     nextVariantIndex = fullImages.length
    // }
    // const onlyFilteredImages = [] || productImages && productImages.filter((_, i) => i >= thisVariantIndex && i < nextVariantIndex)

    // Use all images instead of filtering
    const onlyFilteredImages = productImages ? [...productImages] : [];

    // always add the alt image too, if there is one
    if (altImg.length > 0) {
        // MODIFIED: Don't remove the first image, just add the alt image at the beginning
        // onlyFilteredImages.shift()
        onlyFilteredImages.unshift(altImg.get(0).dataset['src'])
    }

    // hero image:
    const heroImage = onlyFilteredImages[0]
    // const hoverImage = onlyFilteredImages.length > 1 ? onlyFilteredImages[1] : null
    const hoverImage = false

    console.log('HOVERING OVER TILE, HERO IMAGE: ' + heroImage)
    console.log('HOVERING OVER TILE, HOVER IMAGE: ' + hoverImage)


    if (hoverImage) {
        el.addClass('hoverable')
        el.find('.ProductItem__ImageWrapper img.ProductItem__Image').after('<img class="secondary-image" src="' + hoverImage + '">')
    }

    callback(product)
}

const carouselOptions = { wrapAround: true, cellAlign: "left" };

$(function () {
    const items = $(".ProductItem");
    // let hydrateTimeout = null;
    // let initTimeout = null;
    items.each( function (e) {
        const $el = $(this);

        if ($el.find(".product-item-mobile-carousel").is(":visible")) return;
        if ($el.hasClass("product-item-hovered")) return;

        const handle = $el.data("product-handle");

        hydrateCarousel(
            $el,
            handle,
            (product) => {
                console.log(product)
                $el.on("click", function (e) {
                    const target = e.target;
                    if (
                        target.nodeName === "IMG" ||
                        target.classList.contains("product-item-name")
                    ) {
                        window.location = product.url;
                    }
                });
            }
        );
    });
});
